import { createFileRoute } from '@tanstack/react-router'

import MemberDetailSettings from './-components/$memberId'

export const Route = createFileRoute('/_authenticated/$alias/settings/members/$memberId')(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  return <MemberDetailSettings />
}
